import React, { Component } from 'react';
interface ErrorBoundaryProps {
  children: React.ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
    error: null
  };
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }
  handleRetry = () => {
    this.setState({
      hasError: false,
      error: null
    });
    window.location.reload();
  };
  render() {
    if (this.state.hasError) {
      return <div className="flex items-center justify-center min-h-screen bg-[#050505]" data-id="element-1099">
          <div className="flex flex-col items-center gap-6 p-8 max-w-md text-center" data-id="element-1100">
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-1101">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-1102">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" data-id="element-1103" />
              </svg>
            </div>
            <div data-id="element-1104">
              <h2 className="text-xl font-bold text-white mb-2" data-id="element-1105">
                Something went wrong
              </h2>
              <p className="text-gray-400 text-sm font-mono" data-id="element-1106">
                A page failed to load. This can happen after a new deployment or
                due to a network issue.
              </p>
            </div>
            <button onClick={this.handleRetry} className="px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-[#050505]" data-id="element-1107">
              Retry
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}